<div class="fixed inset-0 z-50 grid place-items-center bg-black/50 backdrop-blur-sm p-4">
  <div class="relative w-full max-w-5xl max-h-[90vh] overflow-hidden rounded-2xl border border-border-color bg-white shadow-[0_12px_36px_var(--box-shadow-color)]">
    <header class="flex items-center justify-between bg-gradient-to-r from-[var(--primary-color)] via-[var(--primary-color-hover)] to-[var(--second-color)] px-6 py-4 text-light-color">
      <div class="flex items-center gap-3">
        <i class="fa-regular fa-calendar text-2xl"></i>
        <h1 class="text-xl font-semibold">Detalhes do Agendamento</h1>
      </div>
      <button
        type="button"
        class="flex h-10 w-10 items-center justify-center rounded-full border border-white/30 bg-white/10 text-white transition hover:bg-white/20"
        (click)="handleCloseModal()">
        <i class="fa-solid fa-times"></i>
      </button>
    </header>

    <div class="grid gap-4 overflow-y-auto px-6 py-5 md:grid-cols-2">
      <section class="rounded-base border border-border-color bg-white p-4 shadow-sm">
        <h2 class="text-base font-semibold text-dark-color mb-3">Informações do Cliente</h2>
        <div class="flex items-center gap-3">
          <img
            src="https://api.dicebear.com/7.x/notionists/svg?scale=200&seed=123"
            class="h-12 w-12 rounded-full border border-border-color bg-light-color" />
          <div class="flex flex-col text-sm text-dark-color">
            <span class="font-semibold text-base">{{ objectData?.clientName }}</span>
            <span class="flex items-center gap-2 text-dark-color/70">
              <i class="fa-solid fa-phone text-xs"></i>
              {{ objectData?.clientPhone }}
            </span>
          </div>
        </div>
      </section>

      <section class="rounded-base border border-border-color bg-white p-4 shadow-sm">
        <h2 class="text-base font-semibold text-dark-color mb-3">Detalhes do Agendamento</h2>
        <div class="space-y-3 text-sm text-dark-color">
          <div class="flex items-center justify-between">
            <span class="text-dark-color/70">Status</span>
            <span
              class="inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold text-white"
              [ngClass]="{
                'bg-green-500': objectData?.status === 'confirmed',
                'bg-yellow-500': objectData?.status === 'scheduled',
                'bg-red-500': objectData?.status === 'canceled',
                'bg-gray-800': objectData?.status === 'rescheduled',
                'bg-blue-500': objectData?.status === 'in_progress',
                'bg-purple-500': objectData?.status === 'completed',
                'bg-orange-500': objectData?.status === 'no_show'
              }">
              {{ getStatusEnum(objectData?.status) }}
            </span>
          </div>
          <div class="flex items-center justify-between">
            <span class="text-dark-color/70">Data</span>
            <span class="font-semibold">{{ objectData.date | date: 'EEE dd/MM' | uppercase }}</span>
          </div>
          <div class="flex items-center justify-between">
            <span class="text-dark-color/70">Horário</span>
            <span class="font-semibold">{{ objectData.startTime }} - {{ objectData.endTime }}</span>
          </div>
        </div>
      </section>

      <section class="md:col-span-2 rounded-base border border-border-color bg-white p-4 shadow-sm">
        <h2 class="text-base font-semibold text-dark-color mb-3">Observações</h2>
        <p class="rounded-base border border-border-color bg-light-color px-3 py-3 text-sm text-dark-color">
          {{ objectData.notes || 'Sem observações.' }}
        </p>
      </section>
    </div>

    <div class="flex flex-col gap-3 border-t border-border-color px-6 py-4 md:flex-row md:items-center md:justify-end">
      <button
        type="button"
        class="inline-flex items-center gap-2 rounded-base border border-border-color bg-white px-4 py-2 text-sm font-semibold text-dark-color shadow-sm transition hover:border-primary-color"
        (click)="handleOpenModalEncaixes()">
        <i class="fa-solid fa-calendar-plus text-primary-color"></i>
        Encaixes
      </button>
      <button
        type="button"
        class="inline-flex items-center gap-2 rounded-base border border-border-color bg-white px-4 py-2 text-sm font-semibold text-dark-color shadow-sm transition hover:border-primary-color"
        (click)="handleOpenModalReeschedule(objectData)">
        <i class="fa-regular fa-clock text-primary-color"></i>
        Remarcar
      </button>
      <button
        type="button"
        class="inline-flex items-center gap-2 rounded-base bg-primary-color px-4 py-2 text-sm font-semibold text-white shadow transition hover:bg-primary-hover"
        (click)="handleOpenModalCancelarAgendamento()">
        <i class="fa-regular fa-pen-to-square"></i>
        Editar
      </button>
    </div>
  </div>
</div>

<ng-container *ngIf="openModalCancelarAgendamento">
  <app-editar-agendamento
    [appointmentObject]="objectData"
    (closeModal)="handleCloseSimpleModal()"
    (closeModalUpdate)="handleFecharModalCancelarAgendamento()"></app-editar-agendamento>
</ng-container>

<ng-container *ngIf="openModalEncaixes">
  <app-encaixe-agendamento
    [objectData]="appointMentsFittings"
    [objectDefaultInfoAppointment]="objectDefaultInfoAppointment"
    (closeModal)="handleCloseModalEncaixes()"
    (requestUpdateAppointment)="handleUpdateData()"></app-encaixe-agendamento>
</ng-container>

<ng-container *ngIf="isOpenModalReeschedule">
  <app-remarcar-agendamento
    [objectRefAppointment]="selectedAppointmentToReeschedule"
    (closeModal)="handleCloseModalReeschedule()"
    (updateAppointment)="handleFecharModalReagendamento()"></app-remarcar-agendamento>
</ng-container>
